<!-- Scrollable thread tabs -->
<div class="tabs-scroll">
  @for (tab of $tabs(); track tab.threadId) {
    <agent-thread-tab [attr.data-thread-id]="tab.threadId" [tab]="tab" [isActive]="tab.threadId === $activeTabId()" [showUnreadIndicator]="tab.unread && tab.threadId !== $activeTabId()" [streaming]="tab.streaming && tab.threadId !== $activeTabId()" (activate)="onTabActivated($event)" (close)="onTabClosed($event)" />
  }
</div>

<!-- "Ask Workbuddy" tab -->
<agent-thread-tab class="new-chat-tab" [tab]="newChatTab" [isActive]="$newChatActive()" [showLogo]="true" [showCloseButton]="false" (activate)="onNewChat()" />

<!-- History toggle button -->
<agent-thread-tab class="history-tab" [tab]="historyTab" [isActive]="$historyOpen()" [icon]="'fa-regular fa-clock-rotate-left'" [showCloseButton]="false" (activate)="toggleHistory()" />

<!-- History Popover — rendered on document.body via portal to escape stacking contexts -->
<ng-template #historyPopoverTpl>
  <div class="history-popover" (click)="$event.stopPropagation()">
    <!-- Shown above the list rather than instead of it, so a failed refresh still leaves any
         previously loaded chats reachable instead of blanking the popover. -->
    @if ($historyError()) {
      <div class="history-error" role="status">{{ $historyError() }}</div>
    }
    <agent-thread-list [threads]="$threads()" [loading]="$loading()" [threadStates]="$threadStates()" [showActiveIndicators]="true" (threadSelected)="onSelectThread($event)" (threadDeleted)="onDeleteThread($event)" />
  </div>
</ng-template>